export default __webpack_public_path__ + "static/media/28.931773a6.png";